<template>
  <section class="farm-market-page">
    <div v-if="!hideTabs" class="farm-market-tabs">
      <button type="button" :class="{ active: activeTab === 'shop' }" @click="activeTab = 'shop'">每日商店 <b>{{ shopList.length }}</b></button>
      <button type="button" :class="{ active: activeTab === 'treasure' }" @click="activeTab = 'treasure'">珍宝阁 <b>{{ currentSynthesisList.length }}</b></button>
      <Button size="small" type="warning" :loading="loading" @click="refreshAll">刷新</Button>
    </div>

    <div v-show="activeTab === 'shop'" class="farm-market-panel">
      <div class="farm-market-heading"><div><span class="farm-panel-kicker">每日商店</span><h3>今日上架商品</h3></div><div class="farm-market-heading-tools"><input v-model.trim="shopKeyword" class="farm-market-search" type="search" placeholder="搜索商品" /><strong>共 {{ filteredShopList.length }} 件</strong></div></div>
      <div class="farm-market-list">
        <article v-for="item in filteredShopList" :key="'shop-' + item.marketId" class="farm-market-row">
          <div class="farm-market-row-content"><div class="farm-market-row-title"><span class="market-glyph" style="background: #496bb3"><span class="cave-xian-glyph">{{ marketGlyphText(item) }}</span></span><strong>{{ item.marketName || '未命名商品' }}</strong><Tag color="blue">剩余 {{ item.marketNum || 0 }} 次</Tag></div><div class="farm-market-row-facts"><span>价格 <b>{{ item.marketPrice ? item.marketPrice + ' ' + priceTypeText(item.priceType) : '-' }}</b></span><span>最低等级 <b>{{ item.marketLevel || '无限制' }}</b></span><span v-if="item.typeDec">类型 <b>{{ item.typeDec }}</b></span><span v-if="item.level">装备等级 <b>Lv.{{ item.level }}</b></span><span v-for="attr in shopAttributes(item)" :key="attr.label">{{ attr.label }} <b>{{ attr.value }}</b></span></div><p v-if="item.marketDec" class="farm-market-row-desc">{{ item.marketDec }}</p></div>
          <div class="farm-market-row-actions"><Button size="small" type="primary" :disabled="Number(item.marketNum || 0) <= 0" @click="purchaseShopItem(item)">购买</Button><Button size="small" class="farm-market-batch-button" :disabled="Number(item.marketNum || 0) <= 0" @click="openBatch('shop', item)">批量</Button></div>
        </article>
        <div v-if="!filteredShopList.length" class="farm-market-empty">暂无符合条件的商品</div>
      </div>
    </div>

    <div v-show="activeTab === 'treasure'" class="farm-market-panel">
      <div class="farm-market-heading"><div><span class="farm-panel-kicker">珍宝阁</span><h3>分类兑换与合成</h3></div><div class="farm-market-heading-tools"><input v-model.trim="synthesisKeyword" class="farm-market-search" type="search" placeholder="搜索珍宝" /><strong>当前 {{ filteredCurrentSynthesisList.length }} 件</strong></div></div>
      <div class="farm-treasure-tabs"><button v-for="tab in synthesisTabs" :key="tab.type" type="button" :class="{ active: currentType === tab.type }" @click="switchType(tab.type)">{{ tab.name }} <b>{{ synthesisCount(tab.type) }}</b></button></div>
      <div class="farm-market-list">
        <article v-for="item in filteredCurrentSynthesisList" :key="'syn-' + item.syntheticId" class="farm-market-row farm-synthesis-row">
          <div class="farm-market-row-content"><div class="farm-market-row-title"><span class="market-glyph market-glyph-treasure"><span class="cave-xian-glyph">{{ marketGlyphText(item) }}</span></span><strong>{{ item.syntheticName || '未命名珍宝' }}</strong><Tag v-if="!isXinfaItem(item)" :color="qualityTagColor(item.color)">{{ qualityLabel(item.color) }}</Tag></div><div class="farm-market-row-facts"><span>剩余 <b>{{ item.syntheticNum > 999 ? '无限制' : (item.syntheticNum || 0) }} 次</b></span><span v-if="item.syntheticRealm">境界 <b>{{ item.syntheticRealm }}</b></span><span v-if="item.syntheticLevel">等级 <b>{{ item.syntheticLevel }}</b></span><span v-for="mat in synthesisMaterials(item)" :key="mat.name">{{ mat.name }} <b>x{{ mat.num }}</b></span></div><p v-if="item.syntheticDesci" class="farm-market-row-desc">{{ item.syntheticDesci }}</p></div>
          <div class="farm-market-row-actions"><Button size="small" type="primary" :disabled="item.syntheticNum === 0" @click="synthesisItem(item)">合成</Button><Button size="small" class="farm-market-batch-button" :disabled="item.syntheticNum === 0" @click="openBatch('synthesis', item)">批量</Button></div>
        </article>
        <div v-if="!filteredCurrentSynthesisList.length" class="farm-market-empty">当前分类暂无符合条件的内容</div>
      </div>
    </div>

    <Modal v-model="batchEject" width="360" :title="batchTitle" @on-ok="confirmBatchAction"><InputNumber v-model="batchNum" :min="1" :max="batchMax" style="width:100%" placeholder="请输入数量" /></Modal>
  </section>
</template>

<script>
import Im from '../Im'

export default {
  name: 'CaveFarmMarket',
  props: {
    initialTab: { type: String, default: 'shop' },
    hideTabs: { type: Boolean, default: false }
  },
  watch: {
    initialTab (value) {
      this.activeTab = value === 'treasure' ? 'treasure' : 'shop'
    }
  },
  data () {
    return {
      activeTab: this.initialTab === 'treasure' ? 'treasure' : 'shop',
      loading: false,
      shopKeyword: '',
      synthesisKeyword: '',
      shopList: [],
      synthesisTabs: [{ type: 2, name: '限时活动' }, { type: 1, name: '丹方' }, { type: 3, name: '材料' }, { type: 4, name: '秘籍' }, { type: 5, name: '真灵书' }],
      currentType: 1,
      synthesisList: [],
      synthesisList1: [],
      synthesisList2: [],
      synthesisList3: [],
      synthesisList4: [],
      synthesisList5: [],
      batchEject: false,
      batchNum: 1,
      batchActionType: '',
      marketId: '',
      syntheticId: ''
    }
  },
  computed: {
    currentSynthesisList () {
      const map = { 4: this.synthesisList4, 2: this.synthesisList1, 3: this.synthesisList2, 1: this.synthesisList3, 5: this.synthesisList5 }
      return map[this.currentType] || []
    },
    filteredShopList () {
      const keyword = String(this.shopKeyword || '').toLowerCase()
      if (!keyword) return this.shopList
      return this.shopList.filter(item => [item.marketName, item.marketDec, item.typeDec].some(value => String(value || '').toLowerCase().includes(keyword)))
    },
    filteredCurrentSynthesisList () {
      const keyword = String(this.synthesisKeyword || '').toLowerCase()
      if (!keyword) return this.currentSynthesisList
      return this.currentSynthesisList.filter(item => [item.syntheticName, item.syntheticDesci, item.materOneName, item.materTwoName, item.materThreeName].some(value => String(value || '').toLowerCase().includes(keyword)))
    },
    batchTitle () { return this.batchActionType === 'shop' ? '批量购买' : '批量合成' },
    batchMax () {
      const list = this.batchActionType === 'shop' ? this.shopList : this.currentSynthesisList
      const id = this.batchActionType === 'shop' ? this.marketId : this.syntheticId
      const item = list.find(entry => String(this.batchActionType === 'shop' ? entry.marketId : entry.syntheticId) === String(id))
      if (!item) return 999
      return Math.max(1, Number(this.batchActionType === 'shop' ? item.marketNum : item.syntheticNum) || 1)
    }
  },
  mounted () { this.refreshAll() },
  methods: {
    getCookie (name) { const value = `; ${document.cookie}`; const parts = value.split(`; ${name}=`); return parts.length === 2 ? parts.pop().split(';').shift() : '' },
    refreshAll () { this.loading = true; return Promise.all([this.loadShopList(), this.loadSynthesisList()]).finally(() => { this.loading = false }) },
    loadShopList () { return this.$http.post('/gameMarket/waresList?charaId=' + this.getCookie('charaId')).then(res => { this.shopList = res.data.data || [] }).catch(() => { this.$Notice.warning({ title: '获取每日商店失败' }) }) },
    loadSynthesisList () { return this.$http.post('/gameRealm/getSyntheticList?charaId=' + this.getCookie('charaId')).then(res => { this.synthesisList = res.data.data || []; this.synthesisList1 = []; this.synthesisList2 = []; this.synthesisList3 = []; this.synthesisList4 = []; this.synthesisList5 = []; this.synthesisList.forEach(item => { if (item.syntheticType === 4) this.synthesisList4.push(item); else if (item.syntheticType === 2) this.synthesisList1.push(item); else if (item.syntheticType === 3) this.synthesisList2.push(item); else if (item.syntheticType === 1) this.synthesisList3.push(item); else if (item.syntheticType === 5) this.synthesisList5.push(item) }) }).catch(() => { this.$Notice.warning({ title: '获取珍宝阁商品失败' }) }) },
    switchType (type) { this.currentType = type },
    synthesisCount (type) { const map = { 4: this.synthesisList4, 2: this.synthesisList1, 3: this.synthesisList2, 1: this.synthesisList3, 5: this.synthesisList5 }; return (map[type] || []).length },
    priceTypeText (type) { return type == 0 ? '金币' : '灵石' },
    isXinfaItem (item) {
      if (!item) return false
      const values = [item.marketName, item.syntheticName, item.typeDec, item.itemType, item.goodType, item.type, item.itemTypeDec]
        .filter(value => value !== null && value !== undefined)
        .map(value => String(value))
      if (values.some(value => /野外心法|心法/.test(value))) return true
      const name = String(item.marketName || item.syntheticName || '')
      return /诀$|经$|典$|谱$|录$/.test(name)
    },
    marketGlyphText (item) {
      const name = String(item.marketName || item.syntheticName || '').replace(/[\s·•,，.!！?？:：;；\-_—/\\]/g, '')
      if (!name) return '物'
      const chars = Array.from(name)
      const source = String(item.marketId || item.syntheticId || name)
      let hash = 0
      for (let index = 0; index < source.length; index++) hash = ((hash << 5) - hash) + source.charCodeAt(index)
      return chars[Math.abs(hash) % chars.length]
    },
    distinguishColor (color) { const map = { 1: '#8c94a4', 2: '#879f1e', 3: '#078599', 4: '#036cbe', 5: '#801DAE', 6: '#9e0e42', 7: '#FFA631' }; return map[color] || '#172033' },
    qualityLabel (color) { return ({ 1: '普品', 2: '良品', 3: '上品', 4: '极品', 5: '史诗', 6: '传说', 7: '神话' })[color] || '未知' },
    qualityTagColor (color) { return ({ 1: 'default', 2: 'green', 3: 'blue', 4: 'gold', 5: 'purple', 6: 'red', 7: 'orange' })[color] || 'default' },
    formatPercent (value) { return `${(Number(value) * 100).toFixed(1)}%` },
    shopAttributes (item) {
      const attrs = [{ key: 'life', label: '生命' }, { key: 'mana', label: '真气' }, { key: 'attack', label: '攻击' }, { key: 'magAttack', label: '灵攻' }, { key: 'defense', label: '防御' }, { key: 'magicDefense', label: '法防' }, { key: 'critical', label: '暴击率', percent: true }, { key: 'criDamage', label: '暴伤', percent: true }, { key: 'criticalRegist', label: '抗暴率', percent: true }, { key: 'hitRate', label: '命中', percent: true }, { key: 'evade', label: '闪避', percent: true }, { key: 'speed', label: '速度' }, { key: 'physique', label: '根骨' }, { key: 'dexterous', label: '力道' }, { key: 'spirit', label: '灵力' }, { key: 'pveDamageRatio', label: 'PVE增伤', percent: true }, { key: 'pveReduceRatio', label: 'PVE减伤', percent: true }, { key: 'pvpDamageRatio', label: 'PVP增伤', percent: true }, { key: 'pvpReduceRatio', label: 'PVP减伤', percent: true }]
      return attrs.filter(attr => item[attr.key] !== null && item[attr.key] !== undefined && Number(item[attr.key]) !== 0).map(attr => ({ label: attr.label, value: attr.percent ? this.formatPercent(item[attr.key]) : item[attr.key] }))
    },
    synthesisMaterials (item) { const list = []; if (item.materOneName) list.push({ name: item.materOneName, num: item.materOneNum || 0 }); if (item.materTwoName) list.push({ name: item.materTwoName, num: item.materTwoNum || 0 }); if (item.materThreeName) list.push({ name: item.materThreeName, num: item.materThreeNum || 0 }); if (item.syntheticMoney) list.push({ name: '金币', num: item.syntheticMoney }); if (item.syntheticCoin) list.push({ name: '灵石', num: item.syntheticCoin }); return list },
    purchaseShopItem (item) { return this.buyShop(item.marketId, 1) },
    buyShop (marketId, count, batch) { return this.$http.post('/gameMarket/buyWares?charaId=' + this.getCookie('charaId') + '&waresId=' + marketId + '&waresNum=' + count).then(res => { this.$Notice.warning({ title: res.data.msg }); this.sendShopMessage(res.data.msg); this.$bus.$emit('shopMsg', '商店购买完成'); if (batch) this.$bus.$emit('shopMsg1', '商店批量购买完成'); this.$emit('purchased'); return this.loadShopList() }).catch(err => { this.$Notice.warning({ title: (err.data && err.data.msg) || '购买失败' }) }) },
    sendShopMessage (message) { try { Im.methods.send2(Im.data().chatUser, message, Im.data().chatPindao, '系统消息', Im.data().socketObj) } catch (e) {} },
    synthesisItem (item) { return this.doSynthesis(item.syntheticId, 1) },
    doSynthesis (syntheticId, count, batch) { return this.$http.post(`/gameRealm/breakThroughTheSynthetic?charaId=${this.getCookie('charaId')}&syntheticId=${syntheticId}&syntheticNum=${count}`).then(res => { this.$Notice.success({ title: res.data.msg }); this.$bus.$emit('synthesisMsg', '合成成功'); if (batch) this.$bus.$emit('synthesisMsg1', '批量合成完成'); this.$emit('synthesized'); return this.loadSynthesisList() }).catch(() => { this.$Notice.error({ title: '合成失败' }) }) },
    openBatch (type, item) { this.batchActionType = type; this.batchNum = type === 'shop' ? (item.marketNum || 1) : (item.syntheticNum || 1); if (type === 'shop') this.marketId = item.marketId; else this.syntheticId = item.syntheticId; this.batchEject = true },
    confirmBatchAction () { const count = Math.min(Math.max(1, Number(this.batchNum) || 1), this.batchMax); if (this.batchActionType === 'shop') return this.buyShop(this.marketId, count, true); return this.doSynthesis(this.syntheticId, count, true) }
  }
}
</script>

<style scoped>
.farm-market-page{color:#4f3f29}.farm-market-tabs{display:flex;align-items:center;gap:7px;margin-bottom:10px}.farm-market-tabs button,.farm-treasure-tabs button{min-height:34px;padding:0 13px;color:#896f49;background:#f5ead1;border:1px solid #d6c092;border-radius:4px;cursor:pointer;font-size:12px}.farm-market-tabs button{flex:1}.farm-market-tabs button.active,.farm-treasure-tabs button.active{color:#fff8dd;background:#9b6552;border-color:#7f4c3e}.farm-market-tabs button b,.farm-treasure-tabs button b{margin-left:4px;color:#a55f43;font-size:10px}.farm-market-tabs button.active b,.farm-treasure-tabs button.active b{color:#fff}.farm-market-tabs>.ivu-btn{flex:0 0 auto}.farm-market-panel{padding:11px;background:rgba(255,250,236,.9);border:1px solid #d8c59a;border-radius:4px}.farm-market-heading{display:flex;align-items:end;justify-content:space-between;gap:10px;padding-bottom:8px;border-bottom:1px solid #e2d5b8}.farm-panel-kicker{color:#a0865d;font-size:10px}.farm-market-heading h3{margin:3px 0 0;color:#654a2e;font:900 18px/1.2 "KaiTi","STKaiti",serif}.farm-market-heading>strong{color:#9b6552;font-size:11px}.farm-treasure-tabs{display:flex;gap:5px;padding:9px 0;overflow-x:auto}.farm-treasure-tabs button{flex:0 0 auto;min-height:29px;padding:0 10px;font-size:10px}.farm-market-list{display:grid;align-content:start;gap:5px;max-height:460px;overflow-y:auto;padding-right:5px}.farm-market-list::-webkit-scrollbar{width:6px}.farm-market-list::-webkit-scrollbar-thumb{background:rgba(166,108,77,.45);border-radius:4px}.farm-market-list::-webkit-scrollbar-track{background:rgba(216,197,154,.28);border-radius:4px}.farm-market-row{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:8px 10px;background:#fffaf0;border:1px solid #e1d4b7;border-radius:3px}.farm-market-row:hover{border-color:#bd9850;background:#fff8e7}.farm-market-row-content{min-width:0;flex:1}.farm-market-row-title{display:flex;align-items:center;gap:7px;min-width:0}.farm-market-row-title>strong{overflow:hidden;color:#654d31;font-size:12px;text-overflow:ellipsis;white-space:nowrap}.market-glyph{display:grid;place-items:center;flex:0 0 auto;width:26px;height:26px;color:#fff;border-radius:50%;font-size:13px}.market-glyph-treasure{background:#a66c4d}.farm-market-row-title .ivu-tag{flex:0 0 auto;margin:0;font-size:9px}.farm-market-row-facts{display:flex;flex-wrap:wrap;gap:3px 12px;margin:5px 0 0 33px;color:#998362;font-size:10px;line-height:1.35}.farm-market-row-facts span{white-space:nowrap}.farm-market-row-facts b{color:#6b8490;font-weight:700}.farm-market-row-desc{margin:4px 0 0 33px;color:#9a8464;font-size:10px;line-height:1.35}.farm-market-row-actions{display:flex;flex:0 0 auto;gap:5px}.farm-market-row-actions >>> .ivu-btn{color:#765a38;background:#f5ead1;border-color:#d6c092;box-shadow:none}.farm-market-row-actions >>> .ivu-btn:hover{color:#624725;background:#f8efdd;border-color:#b58a52}.farm-market-row-actions >>> .ivu-btn-primary{color:#fff8df;background:#6b8f70;border-color:#54765b}.farm-market-row-actions >>> .ivu-btn-primary:hover{color:#fff8df;background:#5d8064;border-color:#496c50}.farm-market-row-actions >>> .farm-market-batch-button{color:#fff8df;background:#a67842;border-color:#865d31}.farm-market-row-actions >>> .farm-market-batch-button:hover{color:#fff8df;background:#906c3b;border-color:#714d29}.farm-market-empty{padding:35px 10px;color:#a18a68;text-align:center;font-size:11px}@media(max-width:720px){.farm-market-tabs{flex-wrap:wrap}.farm-market-tabs button{flex:1 1 calc(50% - 4px)}.farm-market-tabs>.ivu-btn{width:100%}.farm-market-list{max-height:calc(100vh - 270px)}.farm-market-row{align-items:flex-start;flex-direction:column}.farm-market-row-actions{width:100%}.farm-market-row-actions .ivu-btn{flex:1}.farm-market-row-facts,.farm-market-row-desc{margin-left:0}}
</style>

<style scoped>
.farm-market-page {
  color: #334155;
}
.farm-market-tabs button,
.farm-treasure-tabs button {
  color: #172033;
  background: #f8fbff;
  border-color: #bfdbfe;
}
.farm-market-tabs button:hover,
.farm-treasure-tabs button:hover {
  color: #172033;
  background: #eff6ff;
  border-color: #93c5fd;
}
.farm-market-tabs button.active,
.farm-treasure-tabs button.active {
  color: #ffffff;
  background: #3978b7;
  border-color: #2f669d;
}
.farm-market-tabs button b,
.farm-treasure-tabs button b {
  color: #172033;
}
.farm-market-tabs button.active b,
.farm-treasure-tabs button.active b {
  color: #dbeafe;
}
.farm-market-panel {
  background: #ffffff;
  border-color: #dbeafe;
}
.farm-market-heading {
  border-bottom-color: #dbeafe;
}
.farm-panel-kicker {
  color: #64748b;
}
.farm-market-heading h3 {
  color: #172033;
}
.farm-market-heading-tools {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  min-width: 0;
}
.farm-market-heading-tools > strong {
  flex: 0 0 auto;
  color: #172033;
  font-size: 11px;
}
.farm-market-search {
  width: 170px;
  min-width: 0;
  height: 28px;
  padding: 0 9px;
  color: #334155;
  background: #f8fbff;
  border: 1px solid #bfdbfe;
  border-radius: 4px;
  outline: none;
  font-size: 11px;
}
.farm-market-search:focus {
  background: #ffffff;
  border-color: #172033;
  box-shadow: 0 0 0 2px rgba(23, 32, 51, .12);
}
.farm-market-search::placeholder {
  color: #94a3b8;
}
.farm-market-row {
  background: #ffffff;
  border-color: #dbeafe;
}
.farm-market-row:hover {
  background: #f8fbff;
  border-color: #93c5fd;
}
.farm-market-row-title > strong {
  color: #172033;
}
.farm-market-row-facts {
  color: #64748b;
}
.farm-market-row-facts b {
  color: #496bb3;
}
.farm-market-row-desc {
  color: #64748b;
}
.market-glyph-treasure {
  background: #496bb3;
}
.farm-market-row-actions >>> .ivu-btn {
  color: #172033;
  background: #eff6ff;
  border-color: #bfdbfe;
}
.farm-market-row-actions >>> .ivu-btn:hover {
  color: #172033;
  background: #dbeafe;
  border-color: #93c5fd;
}
.farm-market-row-actions >>> .ivu-btn-primary,
.farm-market-row-actions >>> .farm-market-batch-button {
  color: #ffffff;
  background: #172033;
  border-color: #172033;
}
.farm-market-row-actions >>> .ivu-btn-primary:hover,
.farm-market-row-actions >>> .farm-market-batch-button:hover {
  color: #ffffff;
  background: #0f172a;
  border-color: #0f172a;
}
.farm-market-empty {
  color: #64748b;
}
@media (max-width: 720px) {
  .farm-market-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .farm-market-heading-tools {
    width: 100%;
    justify-content: space-between;
  }
  .farm-market-search {
    flex: 1;
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cave-farm/CaveFarmMarket.vue